export default {
  allFiscalYears: (state) => state.fiscalYears,
  fiscalYearsLoading: (state) => state.loading
}
